<div class="p-4">
  <div class="flex justify-content-between align-items-center mb-4">
    <div class="font-semibold text-xl">Edycja listy</div>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
  </div>

  <form [formGroup]="editForm">
    <div class="mb-3">
      <p-checkbox
        formControlName="noTimeLimit"
        [binary]="true"
        label="Konta bez limitu czasowego"
        inputId="noTimeLimit"
      ></p-checkbox>
    </div>

    <div class="mb-4" *ngIf="!editForm.value.noTimeLimit">
      <label class="block text-sm text-color-secondary mb-2">Ważność konta (dni)</label>
      <p-inputNumber
        formControlName="validDays"
        styleClass="w-full"
        [min]="1"
        placeholder="240 dni"
      ></p-inputNumber>
    </div>
  </form>

  <div class="flex justify-content-end gap-3">
    <p-button label="Anuluj" [text]="true" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
    <p-button label="Zapisz" icon="pi pi-save" [loading]="loading" (onClick)="save()" data-clarity-unmask="true"></p-button>
  </div>
</div>
